export const useRule = `서비스 이용약관

제1조 (목적)

본 이용약관은 기역기역주식회사(이하 "회사")가 운영하는 라이브커머스 플랫폼 팬버드(이하 "서비스")의 이용과 관련하여, 회사와 이용자(회원 및 셀러)의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.



제2조 (용어의 정의)

① 회원 : 본 서비스에 회원가입하고 셀러의 상품을 구매하거나 방송을 시청하는 개인

② 셀러 : 본 서비스에 입점하여 상품을 등록하고 방송을 통해 판매하는 사업자 또는 개인

③ 방송 : 셀러가 플랫폼 내에서 제공하는 실시간 영상 콘텐츠

④ 코인 : 셀러가 방송 생성 시 사용하는 디지털 자산으로 무통장입금 후 회사의 승인에 따라 충전됨

⑤ 운영자 : 서비스에 홈페이지를 개설하여 운영하는 운영자를 말합니다.

⑥ 회원 탈퇴 : 회원이 이용계약을 해약하는 것을 말합니다.



제3조 (약관의 효력 및 변경)

① 본 약관은 서비스 화면에 게시하거나 기타 방법으로 공지함으로써 효력을 발생합니다.

② 회사는 관련 법령을 위배하지 않는 범위 내에서 약관을 변경할 수 있으며, 변경 시 적용일자 및 개정사유를 명시하여 사전에 공지합니다.

③ 이용자가 변경된 약관에 동의하지 않을 경우, 회원 탈퇴를 요청할 수 있으며, 계속 이용 시 개정 약관에 동의한 것으로 간주합니다.



제4조 (회원가입 및 관리)

① 회원가입은 카카오톡 로그인 방식으로 이루어지며, 고객은 닉네임, 이름, 연락처, 주소를 제공하고, 셀러는 추가로 사업자 관련 정보(대표자명, 사업자명, 사업자등록증, 계좌번호 등)를 제공해야 합니다.

② 셀러는 입점 신청 후 회사의 승인을 받아야 판매 활동이 가능합니다.

③ 회원정보는 언제든지 수정 가능하며, 허위 정보를 기재한 경우 서비스 이용에 제한을 받을 수 있습니다.



제5조 (서비스의 제공 및 변경)

① 회사는 고객에게 상품 구매 및 방송 시청 기능, 셀러에게 방송 생성 및 상품 등록 기능을 제공합니다.

② 서비스의 내용은 회사의 사정에 따라 변경될 수 있으며, 사전 공지를 통해 고지됩니다.



제6조 (서비스의 전부 또는 일부 중단)

① 회사는 다음 각호의 경우 해당 서비스의 전부 또는 일부의 제공을 중단하거나 제한할 수 있습니다.

   1. 천재지변, 전쟁, 폭동, 화재, 파업 등 쟁의행위, 정부기관의 통제, 기타 회사의 합리적인 노력으로 제어할 수 없는 사유가 발생하거나 발생할 우려가 있는 경우

   2. 기간통신사업자로부터 전기통신서비스가 제공되지 않은 경우

   3. 서비스용 설비의 장애 및 정기 점검, 보수점검, 교체 또는 고장, 통신의 두절 등의 사유가 발생한 경우

   4. 서비스가 제3자와의 제휴를 통하여 제공되는 경우에 당해 제휴사업자의 사정에 따라 변경되거나 중지되는 경우

   5. 기타 서비스의 원활한 운영을 현저히 저해하는 사유가 발생한 경우

② 본 조 제1항의 사유로 서비스 내용이 변경 또는 중단되는 경우, 회사는 그로 인해 회원이 입은 손해에 대해 고의 또는 중과실이 없는 한 배상하지 않습니다.

③ 본 조에 따라 서비스 이용을 제한하거나 중지하는 경우에는 회사는 사전에 이를 회원에게 통지하거나 공지합니다. 다만 부득이한 경우 사후에 통지하거나 공지할 수 있습니다.



제7조 (회원가입 및 이용계약의 성립)

① 이 서비스의 회원이 되고자 하는 자는 이용약관 및 개인정보처리방침에 동의한 후 회원가입 신청을 하고, 회사가 이러한 신청에 대하여 승인함으로써 이용계약이 체결됩니다.

② 회사는 회원이 되고자 하는 자의 가입신청에 대하여 서비스 이용 승인을 원칙으로 합니다. 다만, 회사는 다음 각호에 해당하는 신청에 대하여는 승인하지 않을 수 있습니다.

   1. 가입 신청자가 신청일 기준으로 만 18세 미만인 경우

   2. 회원가입 신청 시 입력한 정보가 사실관계와 다르거나 정확하지 않은 경우

   3. 서비스 이용에 필수적인 정보 또는 자격이 충분하지 않은 경우

   4. 가입 신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 단 회사의 회원 재가입 승인을 얻은 경우에는 예외

   5. 회원가입 신청자의 귀책사유로 인하여 회사의 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우

③ 회사는 다음 각호에 해당하는 경우, 승인을 철회 또는 이용을 제한할 수 있습니다.

   1. 가입신청 시 입력한 정보가 허위로 판명된 경우

   2. 다른 회원으로부터 이용 불편에 대한 신고가 접수된 경우

④ 제1항에 따른 신청에 있어 회사는 회원의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.

⑤ 제3항에 따른 승인 철회 또는 이용을 제한하는 구체적인 기준은 이용정책에서 별도로 고지합니다.

⑥ 타인 명의 계정으로 사용 중에 발생하는 피해에 대해서는 보상하지 않습니다.



제8조 (회원정보의 변경)

① 회원은 회원가입 신청 시 기재한 사항이 변경되었을 경우 이메일 등 기타 방법으로 회사에 대하여 그 변경사항을 알려야 하며 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.



제9조 (회사의 의무)

① 회사는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 본 약관이 정하는 바에 따라 지속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다해 노력합니다.

② 회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보 취급방침을 공시하고 준수합니다.

③ 회사가 제공하는 서비스로 인하여 회원에게 손해가 발생한 경우 그러한 손해가 회사의 고의나 과실에 기해 발생한 경우에 한하여 회사에서 책임을 부담합니다.

④ 회사는 정보통신망법, 통신비밀보호법, 전기통신사업 등 서비스의 운영, 유지와 관련 있는 법령을 준수합니다.



제10조 (회원의 의무)

① 회원은 서비스 이용에 필요한 아이디, 비밀번호 등을 안전하게 기밀로 유지해야 합니다. 회원이 자신의 아이디, 비밀번호 등의 관리를 소홀히 하여 발생하는 모든 책임은 회원 본인에게 있습니다.

② 서비스 이용과 관련하여 회원이 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 전적으로 회원이 부담하여야 합니다.

③ 회원은 서비스 요청을 하기 전에 서비스 조건을 확인해야 합니다. 조건을 확인하지 않고 서비스를 이용함으로써 발생하는 모든 손실과 손해에 대한 책임은 회원 본인에게 있습니다.

④ 회원은 회사가 서비스를 안전하게 제공할 수 있도록 회사에 협조해야 합니다. 회사가 회원의 본 약관 및 이용정책 위반행위를 발견하여 회원에게 해당 위반행위에 대하여 소명을 요청할 경우 회원은 회사의 요청에 적극 응해야 합니다.

⑤ 회원은 분쟁이 발생한 경우 분쟁의 해결을 위하여 성실히 임해야 합니다. 분쟁해결에 대한 회원의 불성실로 인하여 회사 또는 상대 회원에게 손해가 발생한 경우 회원은 이에 대한 책임을 부담해야 합니다.

⑥ 서비스의 요청과 수락 행위는 반드시 본인의 이용을 전제로 해야 합니다.

⑦ 회원은 다음 각호의 행위를 해서는 안됩니다.

   1. 회원가입 및 회원정보 변경 시 허위내용을 등록하는 행위

   2. 타인의 정보도용 및 권한양도 및 이전 행위

   3. 회사 및 기타 제3자의 저작권 등 지적재산권에 대한 침해하는 행위

   4. 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위

   5. 외설, 폭력적인 메시지, 화상, 음성 등 공서양속에 반하는 정보를 공개 또는 게시하는 행위

   6. 회사가 무상으로 지급한 쿠폰을 타인에게 양도하는 행위

   7. 사기, 불법 및 악성글 등록 등 건전한 입찰 과정에 방해되는 행위

   8. 불편한 언행을 하는 행위

   9. 회원 간 또는 회사에 성적 불쾌감을 느낄 수 있는 언행을 하는 행위

   10. 자신의 부당한 이익을 위해 회사의 정책을 이용하여 서비스나 앱을 사용하는 행위

   11. 부당한 방법으로 팬버드 서비스를 이용하는 행위

    가. 셀러가 타인의 명의를 도용하거나 허위 거래를 통해 코인을 획득하는 경우

    나. 시스템의 취약점을 이용하여 부당한 이득을 취하는 경우

    다. 기타 회사가 판단하기에 서비스의 신뢰성을 훼손하는 행위



제11조 (셀러의 의무)

   ① 셀러는 상품 정보, 가격, 배송 및 환불정책 등을 사실에 근거하여 정확하게 등록하여야 하며 허위 사실 기재 시 판매 제한 등의 조치를 받을 수 있습니다.

   ② 셀러는 관련 법령(전자상거래법, 통신판매업 신고 등)을 준수해야 하며, 미준수 시 회사는 입점 취소 등의 조치를 취할 수 있습니다.

   ③ 셀러는 고객 개인정보를 정당한 목적 외로 활용하거나 무단으로 보관·유출해서는 안 됩니다.



제12조 (서비스 이용제한 등)

① 회사는 다음 각호에 해당하는 경우 회원에 대하여 서비스 제공을 제한하거나 중지할 수 있습니다.

   1. 회사와 회원 간에 서비스 제공과 관련된 약정이 종료되는 경우

   2. 회원이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우

   3. 회원이 타인의 명의를 도용하여 회원가입을 한 경우

   4. 불법프로그램의 제공 및 운영 방해, 정보통신망법을 위반한 불법 통신 및 해킹, 악성프로그램의 배포, 접속권한 초과 행위 등과 같이 회원이 관련법령을 위반한 경우

   5. 회원이 계속해서 1년 이상 로그인하지 않는 경우

   6. 회원이 본 약관에서 정한 의무사항을 위반한 경우

   7. 기타 불법적이거나 부당한 행위

② 제1항에 따라 서비스 이용이 제한되는 경우 회원이 획득한 혜택과 보유한 권리 등도 모두 소멸되며,
    회사는 이에 대해 별도로 보상하지 않습니다.

③ 제1항에 따라 서비스 이용을 제한하거나 중지하는 경우에는 회사는 사전에 이를 회원에게 통지하거나 공지합니다.
    다만, 부득이한 경우 사후에 통지하거나 공지할 수 있습니다.

④ 회원이 본 약관 및 이용정책 등 제반규정을 위반 또는 악용하거나 부당한 방법으로 이용한다고 회사에서 판단되는 경우,
    회사는 다음과 같은 제재를 취할 수 있습니다.

⑤ 부당한 방법으로 취득한 쿠폰 또는 코인은 회사에서 전액 환수할 수 있습니다.

⑥ 부당한 방법으로 팬버드 서비스 이용 시 회사는 해당 회원에게 별도의 통지 없이 이용중지 및 회원자격을 영구 정지시킬 수 있습니다.



제13조 (회원에 대한 통지)

① 회사는 이동전화 단문메시지 서비스(SMS), 푸시 알림(App push),전화,전자우편 등으로 이용자에게 통지할 수 있습니다.

② 회사는 불특정다수 이용자에 대한 통지의 경우 공지사항으로 게시함으로써 개별 통지에 갈음할 수 있습니다. 다만, 이용자 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다.



제14조 (포인트 및 코인 정책)

① 코인 정책 목적

   1.팬버드 서비스를 이용하는 셀러에 대해서 적용되는 코인 관련 내용을 규정함을 그 목적으로 합니다. 

② 코인 충전

   1.셀러는 무통장입금으로 코인 충전 신청 후, 회사의 승인을 통해 코인을 지급받습니다.

③ 코인 사용

   1.코인 1일 사용 횟수 및 최대사용금액의 제한은 없습니다.

④ 코인 환불

   1.셀러의 귀책사유 없는 경우에 한하여 코인 환불이 가능하며, 환불 수수료가 부과될 수 있습니다.

   2.회사는 환불에 대한 세부 정책을 운영정책으로 별도 고지할 수 있습니다.

⑤ 기타

   1. 회사는 코인의 충전, 사용, 유효기간 및 환불정책에 대해 별도의 운영정책으로 공지할 수 있습니다.



제15조 (회원의 권리와 의무)

① 고객은 상품 구매 시 정확한 정보 제공의 의무를 가지며, 셀러는 고객 정보의 열람 및 차단이 가능합니다.

② 셀러는 법령에 따라 본인의 사업자 정보를 성실히 제공하여야 하며, 허위 등록 시 이용 제한을 받을 수 있습니다.

③ 회원은 서비스 이용 시 다음의 행위를 하여서는 안 됩니다:

   1.허위 정보 등록

   2.타인의 명의 도용

   3.회사 서비스 운영 방해 행위

   4.불법 광고, 욕설, 음란물 게시 등



제16조 (이용제한 및 회원 탈퇴)

① 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며, 회사는 즉시 회원 탈퇴를 처리합니다.

② 회사는 다음의 경우 회원의 서비스 이용을 제한하거나 회원 자격을 박탈할 수 있습니다.

   1.관련 법령 및 본 약관 위반

   2.고의적 시스템 장애 유발

   3.비정상적인 코인 사용



제17조 (책임의 제한)

① 회사는 천재지변, 시스템 오류 등 불가항력 사유로 인한 손해에 대해 책임을 지지 않습니다.

② 회사는 고객과 셀러 간 거래에 개입하지 않으며, 해당 거래로 발생한 분쟁에 책임을 지지 않습니다.



제18조 (문제해결 및 손해배상)

① 회원 간 분쟁으로 발생한 문제에 대해서 일체의 책임을 지지 않습니다. 회원 간 분쟁은 당사자 간에 직접 해결해야 합니다.

② 회원이 이 약관을 위반하거나 관계 법령을 위반하여 회사에 손해가 발생한 경우에는 회사에 그 손해를 배상하여야 합니다.



제19조 (지적재산권)

서비스 내 콘텐츠 및 시스템에 대한 저작권 및 기타 지적재산권은 회사 또는 해당 권리자에게 있으며, 회원은 이를 무단으로 사용하거나 복제할 수 없습니다.



제20조 (재판권 및 준거법)

① 회사와 회원 간 제기된 소송은 대한민국법을 준거법으로 합니다.

② 회사와 회원 간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.



제21조 (게시물 및 콘텐츠 관리)

① 회사는 회원 또는 셀러가 게시하거나 제공하는 콘텐츠가 다음 각 호에 해당한다고 판단하는 경우 사전 통지 없이 삭제 또는 방송 중단 등의 조치를 취할 수 있습니다.
 
   1. 허위 또는 과장된 광고 내용
 
   2. 타인의 권리(저작권, 초상권 등)를 침해하는 경우
  
   3. 음란, 비속어, 폭력 등 사회통념상 부적절한 내용
 
   4. 법령 및 공공질서에 반하는 경우

② 방송 내용에 대한 권리 및 책임은 방송을 생성한 셀러에게 있으며, 회사는 콘텐츠 모니터링 및 삭제 외의 분쟁 해결에 개입하지 않습니다.



부칙

제1조 (시행일) 본 약관은 2025년 6월 23일부터 시행합니다.

제2조 (경과조치) 이 약관 시행 이전에 가입된 회원은 본 약관의 적용을 받으며, 개정 약관 공지 후 계속 이용 시 개정 약관에 동의한 것으로 간주합니다.



`;
